module.exports = __webpack_public_path__ + "assets/638b13334862d3f1ad52160cfb1cb8cf.welcome-fg.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/welcome-fg.png
 ** module id = 843
 ** module chunks = 1
 **/